import Action from "../actions";
import {
    reobject
} from '../helper'
////////////////////////////////////////
const initState = {
    profiles: {},
    settings: {}
};

export default (state = initState, action) => {
    const newState = state;
    switch (action.type) {
        /////////////////////////////////////
        case Action.setProfiles:
            return {
                ...newState,
                profiles: reobject(action.peyload.type, action.peyload.data, newState.profiles)
            }
        /////////////////////////////////////
        case Action.setSettings:
            return {
                ...newState,
                settings: Object.assign({}, action.peyload)
            }
        default:
            return newState;
    }
}